export const HOME_PATH = '/home';
export const ACHIEVEMENTS_PATH = '/achievements';
export const ABOUT_US_PATH = '/about';
export const LOGIN_REGISTER_PATH = '/login-register';
export const USER_PATH = '/user';
export const CATEGORIES_PATH = '/categories';
export const ADD_TASK_PATH = '/add-task';
export const TASK_PATH = '/task/:id';
export const SETTINGS_PATH = '/settings';
